import React, { useState } from "react";
import useSessionDataPduli from "../../costumeHooks/useSessionDataPduli";
import avaDefault from "../../../../general/assets/img/Propic1.svg";
import { LoadingIcon } from "../../../../general/components/Icon/LoadingIcon";
export default function AssesseeInformationSesion() {
  const { dataSessionPduli } = useSessionDataPduli({});
  const [loadImg, setLoadImg] = useState(true);
  const [imgError, setImgError] = useState(false);
  return (
    <div className="bg-secondary-600 p-5 rounded-md">
      <div className=" flex items-center lg:flex-row flex-col w-full">
        <div className="flex-shrink-0 h-20 w-20 relative">
          <img
            className="h-20 w-20 rounded-full bg-white object-center object-cover"
            src={
              dataSessionPduli.konseli?.photo != null && imgError == false
                ? dataSessionPduli.konseli?.photo
                : avaDefault
            }
            // src={dataSessionPduli.konseli?.photo}
            alt=""
            onLoad={() => {
              setLoadImg(false);
            }}
            onError={() => {
              setImgError(true);
              setLoadImg(false);
            }}
          />
          {loadImg ? (
            <div className="absolute top-0 bg-secondary-500 h-20 w-20 rounded-full border-2 border-gray-300 flex justify-center items-center">
              <LoadingIcon className="h-20 w-20 text-primary-500 animate-spin " />
            </div>
          ) : null}
        </div>
        <div className="ml-2  p-2 flex-col flex items-center md:items-start w-full ">
          <div className="border-b w-full pb-2 flex-col flex items-center md:items-start">
            <h3 className="text-3xl font-semibold  text-primary-500 ">
              {dataSessionPduli.konseli?.name}
            </h3>
          </div>
          <div className="mt-1 ">
            <div className="text-sm text-gray-200 ">
              Jenis Kelamin :{" "}
              {dataSessionPduli.konseli?.gender == "P" && "Perempuan"}{" "}
              {dataSessionPduli.konseli?.gender == "L" && "Laki-laki"}
            </div>
            <div className="text-sm text-gray-200 ">
              {dataSessionPduli.konseli?.address}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
